<script setup>
    import { useRoute } from 'vue-router';
    import { onMounted, ref } from 'vue';

    // 遷移情報取得
    const route = useRoute();

    const pathName = ref('');
    onMounted(async () => {
        pathName.value = route.name;
    });
</script>

<style></style>

<template>
    <div id="leftBlock">
        <nav id="menu" style="border: none; padding-top: 5px">
            <div class="menuGroup">
                <ul>
                    <li :class="{ selected: pathName === 'managementlist' }">
                        <!--利用者管理-->
                        <RouterLink :to="{ name: 'managementlist' }" class="links">{{ $t('ManagementSideMenu.parts.button1') }}</RouterLink>
                    </li>
                </ul>
            </div>
            <div class="menuGroup">
                <ul>
                    <li>
                        <div>
                            <ul>
                                <li>
                                    <!--マスタ管理-->
                                    <span style="font-weight: 700">{{ $t('ManagementSideMenu.parts.button2') }}</span>
                                </li>
                            </ul>
                        </div>
                        <div style="padding-left: 14px">
                            <ul>
                                <li :class="{ selected: pathName === 'managementorganizationlist' }">
                                    <!--組織-->
                                    <RouterLink :to="{ name: 'managementorganizationlist' }" class="links" id="orgList">{{ $t('ManagementSideMenu.parts.button3') }}</RouterLink>
                                </li>
                                <li :class="{ selected: pathName === 'managementjobcategorylist' }">
                                    <!--職種-->
                                    <RouterLink :to="{ name: 'managementjobcategorylist' }" class="links" id="jobList">{{ $t('ManagementSideMenu.parts.button4') }}</RouterLink>
                                </li>
                                <li :class="{ selected: pathName === 'managementpositionlist' }">
                                    <!--職位-->
                                    <RouterLink :to="{ name: 'managementpositionlist' }" class="links" id="posList">{{ $t('ManagementSideMenu.parts.button5') }}</RouterLink>
                                </li>
                                <li :class="{ selected: pathName === 'managementemploymenttypelist' }">
                                    <!--雇用形態-->
                                    <RouterLink :to="{ name: 'managementemploymenttypelist' }" class="links" id="etpList">{{ $t('ManagementSideMenu.parts.button6') }}</RouterLink>
                                </li>
                                <li :class="{ selected: pathName === 'managementlocationlist' }">
                                    <!--勤務地-->
                                    <RouterLink :to="{ name: 'managementlocationlist' }" class="links" id="locList">{{ $t('ManagementSideMenu.parts.button7') }}</RouterLink>
                                </li>
                                <li :class="{ selected: pathName === 'managementovertimelist' }">
                                    <!--時間外労働時間-->
                                    <RouterLink :to="{ name: 'managementovertimelist' }" class="links" id="ovtList">{{ $t('ManagementSideMenu.parts.button8') }}</RouterLink>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="menuGroup">
                <ul>
                    <li :class="{ selected: pathName === 'managementupload' }">
                        <!--CSVアップロード履歴-->
                        <RouterLink :to="{ name: 'managementupload' }" class="links">{{ $t('ManagementSideMenu.parts.button9') }}</RouterLink>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
